/* eslint-disable import/no-anonymous-default-export */
import coreApi from "../../lib/coreApi";

const buildQP = (data) => {
  let qp = "";
  for (var key in data) {
    if (data.hasOwnProperty(key) && data[key] !== undefined && data[key] !== "") {
      qp += `&${key}=${data[key]}`;
    }
  }
  if (qp.length > 1) qp = "?" + qp.slice(1);
  return qp;
};

export default {
  // Segments
  listSegments: (data) => coreApi.GET(`/engagement/segments${buildQP(data)}`),
  createSegment: (data) => coreApi.POST("/engagement/segments", data),
  previewSegment: (id) => coreApi.POST(`/engagement/segments/${id}/preview`, {}),

  // Templates
  listTemplates: (data) => coreApi.GET(`/engagement/templates${buildQP(data)}`),

  // Campaigns
  listCampaigns: (data) => coreApi.GET(`/engagement/notification-campaigns${buildQP(data)}`),
  createCampaign: (data) => coreApi.POST("/engagement/notification-campaigns", data),
  launchCampaign: (id) => coreApi.POST(`/engagement/notification-campaigns/${id}/launch`, {}),
  pauseCampaign: (id) => coreApi.POST(`/engagement/notification-campaigns/${id}/pause`, {}),
  cancelCampaign: (id) => coreApi.POST(`/engagement/notification-campaigns/${id}/cancel`, {}),
  getCampaignAnalytics: (id) => coreApi.GET(`/engagement/notification-campaigns/${id}/analytics`),
};
